// src/components/auth/SignedOutHandler.tsx
"use client";

import { useEffect } from "react";
import { useSearchParams, usePathname } from "next/navigation";
import { useRouter } from "@/i18n/navigation";
import { getRouteKeyFromSlug } from "@/lib/localizedRoutes/routeHelpers";
import { protectedRoutes } from "@/i18n/protected-routes";

export function SignedOutHandler({ locale }: { locale: string }) {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();

  useEffect(() => {
    if (searchParams.get("signedOut") === "true") {
      // 1. Check if the current route is protected
      const segments = pathname.split("/").filter(Boolean);
      const firstSlug = segments[0] ?? "";
      const routeKey = getRouteKeyFromSlug(locale, firstSlug);

      if (routeKey && protectedRoutes.includes(routeKey)) {
        // 2. User is on /dashboard or similar: Kick to Home
        router.replace("/");
      } else {
        // 3. Just clean the URL so the flag doesn't stay there forever
        const newUrl = window.location.pathname;
        window.history.replaceState(null, "", newUrl);
      }
    }
  }, [searchParams, pathname, locale, router]);

  return null;
}
